import styled from 'styled-components'

import { Size } from '@/types/size'

type SmallSVGProps = {
  size: Size
  small?: boolean
}
const SmallSVG = styled.svg<SmallSVGProps>`
  width: ${({ small, size }) => (small ? size.width * 0.6 : size.width)}px;
  height: ${({ small, size }) => (small ? size.height * 0.6 : size.height)}px;
`

export default SmallSVG
